// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_ProgressoArquivosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /migration/arquivos/progresso.
 *
 * O pré-voo da E10. NÃO escreve: só conta o que existe, para a tela poder
 * mostrar o tamanho do trabalho antes de alguém apertar o botão — e para saber
 * se já acabou.
 *
 * `migrados + restantes == total`, sempre.
 *
 * O `total` é o de FOTOS que a E7 registrou para esta franquia. Não é o total
 * de arquivos no Creator: fotos sem item nenhum (ponto cego herdado da E7)
 * nunca chegaram ao destino e portanto não aparecem aqui.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_ProgressoArquivosResponseDados {
total: number
migrados: number
restantes: number
concluido: boolean
}

export type Migration_ProgressoArquivosResponse = ApiResponse<Migration_ProgressoArquivosResponseDados>;

registerResponseContract('Migration_ProgressoArquivosResponse', {
  total:     { type: 'number',  required: true },
  migrados:  { type: 'number',  required: true },
  restantes: { type: 'number',  required: true },
  concluido: { type: 'boolean', required: true },
})
